import Ban from 'svg/Ban';
import AlertModal from 'components/modals/AlertModal';

interface Props {
  isOpen: boolean;
  /**
   * `declined-twice` is the prompt shown after a second declined request;
   * `actions` is the confirmation from the player actions sheet.
   */
  variant: 'declined-twice' | 'actions';
  isSubmitting?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const DESCRIPTION: Record<Props['variant'], string> = {
  'declined-twice':
    'You’ve declined this player’s connection request twice, so they can’t send you another. Block them to also hide them from your Played with list.',
  actions:
    'They’ll be removed from your connections and won’t be able to send you connection requests or game invites. You can unblock them anytime at the bottom of your Connections page.',
};

export default function BlockPlayerModal({
  isOpen,
  variant,
  isSubmitting = false,
  onConfirm,
  onCancel,
}: Props) {
  return (
    <AlertModal
      isOpen={isOpen}
      title="Block this player?"
      description={DESCRIPTION[variant]}
      confirmBtnVariant="brand-secondary"
      confirmBtnText="Block player"
      confirmBtnIcon={<Ban className="size-5" />}
      cancelBtnText={variant === 'declined-twice' ? 'Not now' : 'Cancel'}
      secondaryFirst
      loading={isSubmitting}
      onConfirm={onConfirm}
      onCancel={onCancel}
      handleClose={onCancel}
    />
  );
}
